import React, { useContext } from 'react'
import { ThemeProvider, createTheme } from '@mui/material';
import MaterialTable from 'material-table';
import "./facillityMeetings.css";
import { useEffect } from 'react';
import { useState } from 'react';
import { Url } from '../../../../constants/ApiUrlConstants';
import { GET, DELETE } from '../../../Common/HttpMethods/HttpMethods';

// ---------------------------------------------------------------------Context Data--------------------------------------------------------------------------------
import { contextData } from '../../../../context/ContextProvider';

// ---------------------------------------------------------------------React Icons--------------------------------------------------------------------------------
import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import SuccessModal from '../../../Common/Popups/SuccessModal';
import FailModal from '../../../Common/Popups/FailModal';
import { BsDownload } from 'react-icons/bs';
import { FaCheckCircle } from "react-icons/fa";
import { IoIosShareAlt } from "react-icons/io";
import { Cuurent_EMAIL, Cuurent_RBAC_roles, FacilityTableRow, GeneratePDF, firstLineTextFromHtml, getAllToFromOptionalEmailArr, getColumns } from '../../../CommonCase/CommonFunctions';


export const getMeetingData = async ({
  selectedFromDate,
  selectedToDate,
  setLoading,
  setData,
  setDataCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  token4,
}) => {
  try {
    setLoading(true);
    let fromDate = moment(selectedFromDate).format('YYYY-MM-DD');
    let toDate = moment(selectedToDate).format('YYYY-MM-DD');

    const meetingResponse = await GET(
      Url.getMeetingsByTagAndRec
        .replace("{startDate}", `${fromDate}`)
        .replace("{endDate}", `${toDate}`)
        .replace("{deptTagId}", "4"),
      token4
    );

    if (meetingResponse?.SUCCESS) {
      const IndexedData = meetingResponse?.DATA?.scheduleMeeting.map((i, ind) => {
        return { ...i, index: ind + 1 };
      });

      setData(IndexedData);
      setDataCopy(IndexedData);
      setLoading(false);
    } else if (meetingResponse.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (meetingResponse.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to fetch meetings.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to fetch meetings.");
    setOpenFailModal(true);
  }
};

export const handleSearch = (inp, dataCopy, setData) => {
  setData(dataCopy?.filter((i) => {
    return i?.meetingSubject?.toLowerCase()?.includes(inp?.toLowerCase());
  }));
};

export const handleEditPast = (navigate,id) => {
  navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
}

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleSessionExpClose = (navigate,setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleCloseSuccessModal = (setOpenSuccessModal) => {
  setOpenSuccessModal(false);
}

export const handleDeleteMeeting = async ({
  meetingIdToDelete,
  setLoading,
  setOpenWarningModal,
  DELETE,
  Url,
  token4,
  getMeetingData,
  selectedFromDate,
  selectedToDate,
  setData,
  setDataCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  setSuccessMessage,
  setOpenSuccessModal,
}) => {
  setOpenWarningModal(false);
  try {
    setLoading(true);
    const deleteMeetingResp = await DELETE(Url.deleteMeeting.replace("{mid}", `${meetingIdToDelete}`), token4);

    if (deleteMeetingResp.SUCCESS) {
      getMeetingData({
        selectedFromDate,
        selectedToDate,
        setLoading,
        setData,
        setDataCopy,
        setSessionExpiredModal,
        setFailMessage,
        setOpenFailModal,
        token4,
      });
      setLoading(false);
      setSuccessMessage("Meeting deleted Successfully.");
      setOpenSuccessModal(true);
    } else if (deleteMeetingResp.STATUS === 401) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 400) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 403) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 404) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 500) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to delete meeting.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to delete meeting.");
    setOpenFailModal(true);
  }
};



const FacillityMeetings = ({ selectedToDate, selectedFromDate, tableIcons, searchInp, selectedPeriod }) => {
  let token4 = sessionStorage.getItem('TOKEN');
  const theme = createTheme();
  const { setViewPastMeeting, setLoading, setActive } = useContext(contextData);
  const navigate = useNavigate();
  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage4, setFailMessage] = useState("");
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)

   // rbac roles
  let rrbac = Cuurent_RBAC_roles();
  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Meetings Summary");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);

  // ---------------------------------------------------------------------------Data States-------------------------------------------------------------------------

  const [data, setData] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);
  const [meetingIdToDelete, setMeetingIdToDelete] = useState(null);


  useEffect(() => {
    getMeetingData({
      selectedFromDate,
      selectedToDate,
      setLoading,
      setData,
      setDataCopy,
      setSessionExpiredModal,
      setFailMessage,
      setOpenFailModal,
      token4,
    });
  }, [selectedFromDate, selectedToDate]);

  useEffect(() => {
    handleSearch(searchInp, dataCopy, setData);
  }, [searchInp]);


  const titleStyle = {
    borderRight: '1px solid #b8b8b8'
  }
  const dataStyle = {
    borderRight: '1px solid #b8b8b8',
    // fontWeight: "600",
    color: "black",
  }


  var usermail4 = Cuurent_EMAIL();


  const handleEditAccess = (props) => {
    const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(props?.participantsList);

    if (allEmailIdArr?.includes(usermail4)) {
      handleEditPast(navigate,props?.mid)
    }
  }

  useEffect(() => {
    const text = document.getElementsByClassName("MuiTablePagination-selectLabel");
    [...text][0].innerHTML = "Show Entries";
    [...text][0].style.fontSize = "13px"
  }, [])

  const headStyle = {
    borderRight: "1px solid #b8b8b8",
    padding: "0px 6px",
    whiteSpace: "nowrap"
  }

  const Hr_backgroundColor = "#ff9b00";
  const DeptType = "Fa";

  const columns = getColumns(headStyle, titleStyle, dataStyle, usermail4, rbac, setViewPastMeeting, handleEditAccess, Hr_backgroundColor, DeptType, navigate);





  const tableHeaderStyle = {
    backgroundColor: '#FFF2C6',
    color: "#FF9B00",
    fontWeight: "bold",
    height: 20
  };


  return (
    <div className="Facillity-table-container" style={{ marginTop: "10px" }}>
      <ThemeProvider theme={theme}>
        <MaterialTable
          data={data}
          localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
          columns={columns}
          icons={tableIcons}
          options={{
            // showTitle:false,
            toolbar: false,
            // headerStyle: tableHeaderStyle,
            search: false,
            pageSizeOptions: [5, 10, 15, 20],
            pageSize: 10,
            draggable: false,
            headerStyle: {
              position: 'sticky',
              top: -1,
              ...tableHeaderStyle
            },
            maxBodyHeight: '57vh',
            minBodyHeight: '57vh'
            // maxBodyHeight: 'calc(100vh - 265px)',
          }}
        />
      </ThemeProvider>
      {/* ---------------------------------------------------------------------------Popups--------------------------------------------------------------------------------- */}
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>handleCloseSuccessModal(setOpenSuccessModal)}
        recallFunctiononClose={()=>handleCloseSuccessModal(setOpenSuccessModal)}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage4={failMessage4}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage4={failMessage4}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleSessionExpClose(navigate,setActive)}
        recallFunctiononClose={()=>handleSessionExpClose(navigate,setActive)}
      />
      {/* warning modal */}
      <FailModal
        openFailModal={openWarningModal}
        setOpenFailModal={setOpenWarningModal}
        failMessage4={failMessage4}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleDeleteMeeting({
          meetingIdToDelete,
          setLoading,
          setOpenWarningModal,
          DELETE,
          Url,
          token4,
          getMeetingData,
          selectedFromDate,
          selectedToDate,
          setData,
          setDataCopy,
          setSessionExpiredModal,
          setFailMessage,
          setOpenFailModal,
          setSuccessMessage,
          setOpenSuccessModal,
        })}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />
    </div>
  )
}

export default FacillityMeetings